import { usePermissionsManagerAPIInterface } from "@dealer-center/ddc-pages-permissions-manager-fetch";

import { useEffect, useState } from "react";
import { PagesPermissionsManagerUiDisplay } from "./Display";

export const PagesPermissionsManagerUi = () => {
  const [nameInput, setNameInput] = useState("");
  const [name, setName] = useState("");
  const { data, error, isLoading } = usePermissionsManagerAPIInterface({
    name
  });
  useEffect(() => {
    document.title = "PermissionsManager";
  }, []);
  return (
    <PagesPermissionsManagerUiDisplay
      data={data}
      error={error ? error.message : undefined}
      loading={isLoading}
      nameInput={nameInput}
      setName={setName}
      setNameInput={setNameInput}
    />
  );
};
